import { Dispatch } from "redux";
import { FETCH_TOGGLE } from "./types";

export const dispatchToggle = (toggleName: string, getValue: () => Promise<boolean>) => {
    return async (dispatch: Dispatch<any>) => {
        dispatch({ type: FETCH_TOGGLE, payload: [] });
        const response = await getValue();
        dispatch({ type: FETCH_TOGGLE, payload: { name: toggleName, value: response } });
    };
};

